import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type ClientAvatarProps = {
  size: "large" | "small";
  variant: Variant;
  isBold: boolean;
  name: string;
  isActive?: boolean;
};

export type Variant =
  | "brand"
  | "gold"
  | "primaryBackground"
  | "rose"
  | "violet";

export const getVariantClass = (
  variant: Variant,
): { background: string; text: string } => {
  const variantMap: Record<Variant, { background: string; text: string }> = {
    gold: {
      background: "bg-gold-default",
      text: "text-background/primary",
    },
    rose: {
      background: "bg-rose-default",
      text: "text-background/primary",
    },
    brand: {
      background: "bg-brand-default",
      text: "text-background/primary",
    },
    violet: {
      background: "bg-violet-default",
      text: "text-background/primary",
    },
    primaryBackground: {
      background: "bg-background/tertiary",
      text: "text-text/primary",
    },
  };

  return variantMap[variant];
};

export const ClientAvatar = ({
  size,
  variant,
  isBold,
  name,
  isActive,
}: ClientAvatarProps) => {
  const initial = name.trim().charAt(0).toUpperCase();
  const variantClasses = getVariantClass(variant);

  return (
    <div className="relative" data-testid="client-avatar-container">
      <div
        className={cnTwMerge(
          "flex justify-center items-center shrink-0 rounded-full",
          size === "large" ? "w-10 h-10" : "w-6 h-6",
          variantClasses.background,
        )}
        data-testid="client-avatar"
      >
        <span
          className={cnTwMerge(
            size === "large" ? "text-2xl" : "text-xs",
            isBold ? "font-semibold" : "font-regular",
            variantClasses.text,
          )}
          data-testid="client-avatar-initial"
        >
          {initial}
        </span>
      </div>
      {isActive ? (
        <span
          className={cnTwMerge(
            "absolute w-2 h-2 shrink-0 rounded-full bg-border/positive z-10",
            size === "small" ? "bottom-0 right-0" : "bottom-0.5 right-0.5",
          )}
          data-testid="client-avatar-active-indicator"
        />
      ) : null}
    </div>
  );
};
